/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const isString = (input: any): input is string => {
  return typeof input === 'string'
}
export const handleHref = (value: string) => {
  return value.startsWith('/') || value.startsWith('http') ? value : value.startsWith('#') ? value : `/${value}`
}
